const API_URLS = {
  production: {
    http: "https://iwave-ishield.com:4000/graphql",
    ws: "wss://iwave-ishield.com:4000/graphql",
  },
  development: {
    http: "http://localhost:4000/graphql",
    ws: "ws://localhost:4000/graphql",
  },
  test: {
    http: "http://127.0.0.1:4000/graphql",
    ws: "ws://127.0.0.1:4000/graphql",
  },
  chaos: {
    http: "http://127.0.0.1:4000/graphql",
    ws: "ws://127.0.0.1:4000/graphql",
  },
};

const environment = process.env.REACT_APP_ENV || "production";
const apiUrls = API_URLS[environment] || API_URLS.production;
const apiBaseUrl = apiUrls.http.replace(/\/graphql\/?$/, "");

export { API_URLS, apiBaseUrl };
